// src/modules/IntegratedMessaging/hooks/useCreateIntegration.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { IntegratedMessagingApiAdapter } from '../adapters/IntegratedMessagingApiAdapter';

// crea tu HttpClient
const httpClient = createHttpClient(apiClientWH);
const adapter = new IntegratedMessagingApiAdapter(httpClient);

export interface CreateIntegrationPayload {
  courier_id: number;
  name: string;
  data: Record<string, any>;
  visibility?: 'public' | 'private';
  private_team_ids?: number[];
}

export const useCreateIntegration = () => {
  const qc = useQueryClient();

  return useMutation({
    // definimos la función que lanza la petición
    mutationFn: (payload: CreateIntegrationPayload) =>
      adapter.createIntegration(payload),

    // al tener éxito invalidamos la lista
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['courier-integrations'] });
    },
  });
};
